import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLikeButtonState, useLikeButtonVote } from '../../hooks';
import type { NomineeType, PollType } from '../../types';
import { trackSectionNomineeVoteClick } from '../../utils/trackUtils';

import * as style from './appContext.module.scss';

const LikeButton = ({ nominee, poll }: { nominee: NomineeType; poll: PollType }) => {
  const { t } = useTranslation();

  const { isVoted, isButtonDisabled, isButtonHidden } = useLikeButtonState(poll, nominee);
  const { vote } = useLikeButtonVote(poll, nominee);

  return (
    <>
      {!isButtonHidden && (
        <PkButton
          className={style.btnVote}
          color='interaction'
          appearance='outlined'
          onPkClick={() => vote(trackSectionNomineeVoteClick)}
          disabled={isVoted || isButtonDisabled}>
          {isVoted ? (
            <div className={style.gotsVoted}>
              {isVoted && <span className={style.votedLabel}>{t('gots.voted')}</span>}
              <PkIcon name='actions-check' size='24' color='interaction' />
            </div>
          ) : (
            t('gots.vote')
          )}
        </PkButton>
      )}
      {isButtonHidden && isVoted && (
        <span className={style.votedIcon}>
          <span>
            <PkIcon name='actions-check' size='24' color='interaction' />
          </span>
          <span className={style.votedLabel}>{t('gots.voted')}</span>
        </span>
      )}
    </>
  );
};

export default memo(LikeButton);
